import React from 'react';

// Source icon — inline so the section carries no image dependency.
const SourceIcon = () => (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="6.4" stroke="currentColor" strokeWidth="1.3" />
        <path d="M1.6 8h12.8M8 1.6c1.7 1.8 2.6 4 2.6 6.4S9.7 12.6 8 14.4C6.3 12.6 5.4 10.4 5.4 8S6.3 3.4 8 1.6Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
);

const ODDS = [
    { color: '#F9E84B', title: '', lead: true, value: <>We <em>all</em> think we can outperform the market!</>, source: '' },
    { color: '#F86A78', title: '90% of Startups fail', value: '90%', source: 'Startup Genome' },
    { color: '#4DEB9F', title: '% Startups that get VC funding', value: '0.05%', source: 'CB Insights' },
    { color: '#7891FF', title: "VC-backed Startups that don't return money", value: '75%', source: 'Failory' },
];

const AboutCustomCarousel = () => (
    <section className="lp-about-odds">
        <div className="lp-container">
            <div className="lp-about-odds-cards">
                {ODDS.map((o, i) => (
                    <div className="lp-about-odds-card" key={i} style={{ background: o.color }} data-lp-reveal data-lp-delay={180 + i * 90}>
                        <h3 className="ttl">{o.title}</h3>
                        <div className="bub">
                            <span className={o.lead ? 'val val--lead' : 'val'}>{o.value}</span>
                        </div>
                        <div className="src">{o.source && <><SourceIcon />Source:&nbsp;<em>{o.source}</em></>}</div>
                    </div>
                ))}
            </div>
            <p className='lp-h2'>Whoever you are we give you the tools to beat these odds</p>
        </div>
    </section>
);

export default AboutCustomCarousel;
